import ReactGA from "react-ga";
import ReactGA4 from "react-ga4";
  
const useGAEventsTracker = (category = "Event Category") =>{
    const trackEvent = (action = "action", value="value", label = "click") => {
        ReactGA.event({ category, action, label, value});
        ReactGA4.event({ category, action, label, value});
    };
    return trackEvent;
};

const pageScrolled = (e, category = "Scroll") => {
    const scrollY = Number(window.scrollY);
    const trackEvent = (action = "action", label = scrollY) => {
      ReactGA.event({ category, action, label });
      ReactGA4.event({ category, action, label});
    };
    return trackEvent();
  }

export {useGAEventsTracker, pageScrolled};


